module.exports = __webpack_public_path__ + "media/images/warning-74d9cee2f302c55e37fbfbb8a1c07ece.png";